import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  // almacenamiento del browser
  private storage: any;
  // almacenamiento de la aplicacion
  private data: any;

  constructor(private router: Router) {
    this.storage = localStorage;
  }

  // obtener data almacenada en variable de almacenamiento de la aplicacion
  public getData(): any {
    return this.data;
  }

  // setea data en variable para almacenamiento de la aplicacion
  public setData(newData: any) {
    this.data = newData;
  }

  // metodo para remover un item del almacenamiento local
  popLocalStorageItem(itemName: string): void {
    this.storage.removeItem(itemName);
  }

  // metodo para obtener un item del almacenamiento local
  getItem(itemName: string): string {
    const item = this.storage.getItem(itemName);
    return item;
  }

  public setItem(name: string, obj: any): void {
    localStorage.setItem(name, JSON.stringify(obj));
  }

  public removeItem(name: string): void{
    localStorage.removeItem(name);
  }

}
